import { render, staticRenderFns } from "./appointments.vue?vue&type=template&id=759be228&scoped=true"
import script from "./appointments.vue?vue&type=script&lang=js"
export * from "./appointments.vue?vue&type=script&lang=js"
import style0 from "./appointments.vue?vue&type=style&index=0&id=759be228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759be228",
  null
  
)

export default component.exports